import {
  PAGES_SIDEBAR_OPEN_ATTRIBUTE_NAME,
  PAGES_SIDEBAR_ACTIVE_CLASS_NAME,
} from "./constants"

declare global {
  interface Window {
    togglePagesSidebar: (force?: { closed: boolean }) => void
    togglePagesSidebarDropdown: (key: string) => void
    onPagesSidebarSearchInputChange: (event: Event) => void
    onPagesSidebarSearchInputResetButtonOnClick: () => void
  }
}

window.togglePagesSidebar = (force?: { closed: boolean }) => {
  const html = document.documentElement
  if (!html) {
    return
  }

  const isOpen = html.hasAttribute(PAGES_SIDEBAR_OPEN_ATTRIBUTE_NAME)
  const toClose = typeof force?.closed === "boolean" ? force.closed : isOpen

  if (!toClose) {
    html.setAttribute(PAGES_SIDEBAR_OPEN_ATTRIBUTE_NAME, "")
  } else {
    const searchInput = document.querySelector("#pages-sidebar-search-input") as HTMLInputElement
    if (searchInput) {
      searchInput.value = ""
      updateNoPagesFoundMessageVisibility(false)
      searchInput.dispatchEvent(new Event("input", { bubbles: true }))
    }
    
    html.removeAttribute(PAGES_SIDEBAR_OPEN_ATTRIBUTE_NAME)
  }
}

window.togglePagesSidebarDropdown = (key) => {
  const trigger = document.querySelector(`[data-sidebar-dropdown-trigger="${key}"]`)
  const elements = Array.from(document.querySelectorAll(`[data-sidebar-dropdown-target="${key}"]`))
  if (!trigger || !elements) {
    return
  }

  const isClosed = trigger.classList.contains("closed")

  const items = [...elements, trigger]
  items.forEach((element) => {
    element.classList.toggle("closed", !isClosed)
  })

  const activeElement = elements.find(e => e.classList.contains(PAGES_SIDEBAR_ACTIVE_CLASS_NAME))
  if (!activeElement) {
    return
  }

  if (isClosed) {
    // opening the dropdown
    trigger.classList.remove(PAGES_SIDEBAR_ACTIVE_CLASS_NAME)
  } else {
    // closing the dropdown
    trigger.classList.add(PAGES_SIDEBAR_ACTIVE_CLASS_NAME)
  }
}

const updateNoPagesFoundMessageVisibility = (show: boolean) => {
  const noResultsFoundIndicator = document.querySelector("#no-pages-found") as HTMLDivElement
  if (noResultsFoundIndicator) {
    noResultsFoundIndicator.style.display = show ? "flex" : "none"
  }
}

let sidebarSearchTimeout: ReturnType<typeof setTimeout>

window.onPagesSidebarSearchInputChange = (event) => {
  clearTimeout(sidebarSearchTimeout)

  sidebarSearchTimeout = setTimeout(() => {
    const value = (event.target as HTMLInputElement).value

    const items = document.querySelectorAll("[data-pages-sidebar-search-value]")
    const sections = document.querySelectorAll("[data-pages-sidebar-section]")

    let withResults = false

    items.forEach(i => {
      const item = i as HTMLAnchorElement
      const name = item.getAttribute("data-pages-sidebar-search-value")
      if (!name) {
        return
      }

      const visible = value === "" || name.toLowerCase().includes(value.toLowerCase())
      const li = item.closest("li")
      const target = li ?? item
      target.style.display = visible ? "flex" : "none"

      if (visible) {
        withResults = true
      }
    })

    sections.forEach(section => {
      const visibleItems = section.querySelectorAll("li:not([style*='display: none'])")
      const sectionEl = section as HTMLDivElement

      sectionEl.style.display = visibleItems.length > 0 ? "flex" : "none"
    })

    updateNoPagesFoundMessageVisibility(!withResults)
  }, 500)
}

window.onPagesSidebarSearchInputResetButtonOnClick = () => {
  const items = document.querySelectorAll("[data-pages-sidebar-search-value]")
  const sections = document.querySelectorAll("[data-pages-sidebar-section]")

  items.forEach(i => {
    const item = i as HTMLAnchorElement
    const name = item.getAttribute("data-pages-sidebar-search-value")
    if (!name) {
      return
    }
    const li = item.closest("li")
    const target = li ?? item
    target.style.display = "flex"
  })

  sections.forEach(section => {
    const sectionEl = section as HTMLDivElement
    sectionEl.style.display = "flex"
  })

  updateNoPagesFoundMessageVisibility(false)
}
